import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { refreshPartnerSession } from '../services/partner-auth.interceptor';
import { PartnerService } from '../services/partner.service';

/**
 * The partner area needs a partner session. Without a stored token the refresh
 * cookie may still hold one (e.g. after the browser dropped localStorage).
 */
export const partnerGuard = () => {
  const partnerService = inject(PartnerService);
  const router = inject(Router);
  if (partnerService.isLoggedIn()) return true;

  return refreshPartnerSession(partnerService).pipe(
    map(() => true),
    catchError((error) => {
      if (!(error instanceof HttpErrorResponse) || error.status === 401) {
        partnerService.clear();
      }
      return of(router.createUrlTree(['/partner/login']));
    }),
  );
};
